import React from "react";
import "../css/ViewOrderStatistics.css";

function ViewOrderStatistics() {
  return (
    <div className="ViewOrderStatistics-root-container">
      <h4> View Order Staistics </h4>
    </div>
  );
}

export default ViewOrderStatistics;
